<ng-container  *transloco="let t">
<div class="base-header d-flex justify-content-between" (click)="handleRightIconClick()">
  <div class="header-title d-flex align-items-center">
    <span class="material-symbols-rounded"> {{ leftIcon }} </span>
    <div class="title">{{ title }}</div>
  </div>
  <div class="d-flex align-items-center header-actions">
    <ng-container *ngIf="shared !== null">
      <ng-container *ngIf="shared === recordTypeEnum.Shared">
        <div class="d-flex align-items-center gap-2">
          <span class="material-symbols-rounded"> group </span>
          <span class="shared-text">{{ t('common/shared') }}</span>
        </div>
      </ng-container>
      <ng-container *ngIf="shared === recordTypeEnum.Private">
        <div class="d-flex align-items-center gap-2">
          <span class="material-symbols-rounded"> group_off </span>
          <span class="shared-text">{{ t('common/unshared') }}</span>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="mode === modeEnum.VIEW && allowEditMode">
      <span class="material-symbols-rounded pointer"> {{ rightIcon }} </span>
    </ng-container>
  </div>
</div>
<div class="base-content d-flex flex-column">

  <div class="content-padding">
    <ng-content></ng-content>
  </div>
</div>
</ng-container>
